import React from 'react';
import T from 'prop-types';
import { appStore } from '../utils/helpers';

const storeIcons = {
  itunes_connect: 'hicon-apple',
  google_play: 'hicon-play',
  unified: 'hicon-unified',
};

const StoreIcon = ({ store }) => (
  <div className="store-item">
    <i className={storeIcons[appStore(store)]} />
  </div>
);

StoreIcon.propTypes = {
  store: T.oneOf(['itunes_connect', 'google_play', 'unified', 'both']).isRequired,
};
export default StoreIcon;
